module.exports = __webpack_public_path__ + "assets/img/point.da1623ac.png";